import { qq } from "bobjoll/ts/library/gr/dom.q";
import User from 'Library/gr/user';

(qq('.freebies__download') as HTMLLinkElement[]).forEach(freebie => 
    freebie.addEventListener('click', async function(e: Event) {
        e.preventDefault();
        
        if (User.isLogged(true)) {
            window.location.href = freebie.href;
        }
    })
);